/* storybook-check-ignore */
import styled from '@emotion/styled';
import { Button, ButtonProps } from '@opendoor/bricks/core';

const StyledButton = styled(Button)`
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)),
    rgba(8, 45, 230, 1);
  background-blend-mode: soft-light, normal;
`;

export default function SelfTourButton({
  text,
  onClick,
  disabled,
  ...props
}: { text?: string } & Pick<ButtonProps, 'disabled' | 'onClick'> &
  Omit<ButtonProps, 'analyticsName' | 'aria-label'>) {
  return (
    <StyledButton
      width="100%"
      variant="primary"
      color="neutrals0"
      aria-label={text ?? ''}
      analyticsName="cosmos-exclusives-hero-self-tour-by-state"
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {text}
    </StyledButton>
  );
}
